<template>
    <div class="vrm-filter_options__radios">
        <label v-for="option in options" :key="option.id" class="vrm-filter_options__radio">
            <span v-html="finalLabel(option)"></span>
            <div class="radio-button-container">
                <input
                    :id="option.id"
                    :value="option.id"
                    :name="variable"
                    type="radio"
                    :checked="valueSelected === option.id"
                    @change="onChange"
                    @keyup.enter="submit"
                />
            </div>
        </label>
    </div>
</template>

<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularLocaleBundle('installationoverview')
@AngularLocaleBundle('tags')
@AngularLocaleBundle('dashboard')
@AngularLocaleBundle('core')
export default class VrmInstallationOverviewFilterRadio extends Vue {
    @Prop({ type: Array, default: [] })
    options;
    @Prop({ type: String, required: true })
    variable;
    @Model({ type: String, required: true })
    valueSelected;

    finalLabel(option) {
        if (option.i18n) {
            return this.$t(option.i18n, {
                i18nFallback: option.label,
            });
        }
        return option.label;
    }

    onChange(newValue) {
        this.$emit('selected', newValue.target.value);
    }

    submit() {
        this.$emit('submit');
    }
}
</script>
